<div class="main-container-position">
  <div class="container-width">
    <div class="container mx-auto p-4 sm:p-6 md:p-8">
      <div>
        <div class="flex justify-between flex-wrap">
          <h1 class="text-2xl sm:text-3xl md:text-3xl" i18n>
            Angebotsverwaltung
          </h1>
          <div class="flex flex-row items-center space-x-4">
            <button
              routerLink="/add-offer"
              class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-3 rounded-full"
              i18n
              data-testid="company-add-offer-btn"
            >
              Angebot hinzufügen
            </button>
            <!-- <a routerLink="/add-offers" class="flex items-center">
            <span class="material-symbols-outlined">upload</span>
          </a> -->
          </div>
        </div>
      </div>

      <h2 class="text-lg sm:text-xl md:text-2xl" i18n>
        Zur Überprüfung eingereicht
      </h2>
      <div>
        @if (isLoading) {
          <div>
            <app-skeleton-loading
              [showLoadingText]="true"
              [loadingText]="'Angebote werden geladen...'"
              [showTabs]="false"
              [numberOfCards]="4"
              [containerClass]="''"
              [gridClass]="
                'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4'
              "
            ></app-skeleton-loading>
          </div>
        }

        @if (!isLoading) {
          <div class="flex flex-wrap gap-4">
            @if (pendingOffers.length > 0) {
              @for (offer of pendingOffers; track offer) {
                <app-offer-card
                  class="w-[231px]"
                  [offer]="offer"
                  [showStatus]="true"
                  [fromAdvisoryBoard]="false"
                  [showContextMenu]="true"
                  [showActions]="true"
                  (offerDeleted)="handleOfferDeleted($event)"
                ></app-offer-card>
              }
            } @else {
              <div class="col-span-full text-center text-gray-500">
                Es sind noch keine Angebote zur Überprüfung eingereicht.
              </div>
            }
          </div>
        }
      </div>

      <div>
        <h2 class="text-lg sm:text-xl md:text-2xl" i18n>
          Anforderungen zur Änderung
        </h2>
        @if (isLoading) {
          <div>
            <app-skeleton-loading
              [showLoadingText]="false"
              [showTabs]="false"
              [numberOfCards]="4"
              [containerClass]="''"
              [gridClass]="
                'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4'
              "
            ></app-skeleton-loading>
          </div>
        }
        @if (!isLoading) {
          <div class="flex flex-wrap gap-4">
            @if (modificationRequestedOffers.length > 0) {
              @for (offer of modificationRequestedOffers; track offer) {
                <app-offer-card
                  class="w-[231px]"
                  [offer]="offer"
                  [showStatus]="true"
                  [fromAdvisoryBoard]="false"
                  [showContextMenu]="true"
                  [showActions]="true"
                  (offerDeleted)="handleOfferDeleted($event)"
                ></app-offer-card>
              }
            } @else {
              <div class="col-span-full text-center text-gray-500">
                Aktuell keine Anforderungen zur Änderung.
              </div>
            }
          </div>
        }
      </div>
      <div>
        <h2 class="text-lg sm:text-xl md:text-2xl" i18n>
          Öffentliche Angebote
        </h2>
        @if (isLoading) {
          <div>
            <app-skeleton-loading
              [showLoadingText]="false"
              [showTabs]="false"
              [numberOfCards]="4"
              [containerClass]="''"
              [gridClass]="
                'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4'
              "
            ></app-skeleton-loading>
          </div>
        }
        @if (!isLoading) {
          <div class="flex flex-wrap gap-4">
            @if (approvedOffers.length > 0) {
              @for (offer of approvedOffers; track offer) {
                <app-offer-card
                  class="w-[231px]"
                  [offer]="offer"
                  [showStatus]="true"
                  [fromAdvisoryBoard]="false"
                  [showContextMenu]="true"
                  [showActions]="true"
                  (offerDeleted)="handleOfferDeleted($event)"
                ></app-offer-card>
              }
            } @else {
              <div class="col-span-full text-center text-gray-500">
                Es sind noch keine öffentlichen Angebote vorhanden.
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
